export interface AdoptionQuizOption {
  labelKey: string;
  correct: boolean;
}

/** Text-Overlay auf dem Feature-Bild (z. B. Label neben einem Orb).
 *  Position in % relativ zur Bildfläche, vertikal zentriert am Ankerpunkt. */
export interface AdoptionQuizAnnotation {
  textKey: string;
  subTextKey?: string;
  top: number;
  left: number;
}

export interface AdoptionQuiz {
  /** Stable id used as the localStorage seen-marker — never rename once shipped. */
  slug: string;
  image: string;
  bubbleKey: string;
  questionKey: string;
  options: AdoptionQuizOption[];
  annotations?: AdoptionQuizAnnotation[];
}

/** One entry per Adoption-Quiz. New quizzes just get appended here — order
 *  is the order they're shown in across logins until each is solved once. */
export const ADOPTION_QUIZZES: AdoptionQuiz[] = [
  {
    slug: 'twin-tab-bar',
    image: 'assets/images/Adoption/AI-Tutor_Tab_Bar_detail_transp_2.png',
    bubbleKey: 'dialogs.adoptionModal.quizzes.twinTabBar.bubble',
    questionKey: 'dialogs.adoptionModal.quizzes.twinTabBar.question',
    options: [
      { labelKey: 'dialogs.adoptionModal.quizzes.twinTabBar.optionNotPossible', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.twinTabBar.optionTwin', correct: true },
      { labelKey: 'dialogs.adoptionModal.quizzes.twinTabBar.optionSupport', correct: false },
    ],
  },
  {
    slug: 'dozent-exercises',
    image: 'assets/images/Adoption/AI-Tutor_Uebung_erstellen_Dozent.png',
    bubbleKey: 'dialogs.adoptionModal.quizzes.dozentExercises.bubble',
    questionKey: 'dialogs.adoptionModal.quizzes.dozentExercises.question',
    options: [
      { labelKey: 'dialogs.adoptionModal.quizzes.dozentExercises.optionAnalytics', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.dozentExercises.optionDozent', correct: true },
      { labelKey: 'dialogs.adoptionModal.quizzes.dozentExercises.optionChatStyling', correct: false },
    ],
  },
  {
    slug: 'tutor-twin-escalation',
    image: 'assets/images/Adoption/AI-Tutor_Tutor-Twin_3.png',
    bubbleKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.bubble',
    questionKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.question',
    options: [
      { labelKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.optionTwin', correct: true },
      { labelKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.optionSupport', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.optionAssist', correct: false },
    ],
    annotations: [
      {
        textKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.labelTutor',
        subTextKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.labelTutorSub',
        top: 19,
        left: 62,
      },
      {
        textKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.labelTwin',
        subTextKey: 'dialogs.adoptionModal.quizzes.tutorTwinEscalation.labelTwinSub',
        top: 79,
        left: 62,
      },
    ],
  },
  {
    slug: 'exercise-mode',
    image: 'assets/images/Adoption/AI-Tutor_Exercise_Mode.png',
    bubbleKey: 'dialogs.adoptionModal.quizzes.exerciseMode.bubble',
    questionKey: 'dialogs.adoptionModal.quizzes.exerciseMode.question',
    options: [
      { labelKey: 'dialogs.adoptionModal.quizzes.exerciseMode.optionChat', correct: true },
      { labelKey: 'dialogs.adoptionModal.quizzes.exerciseMode.optionShortcut', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.exerciseMode.optionNone', correct: false },
    ],
  },
  {
    slug: 'roles-organisation',
    image: 'assets/images/Adoption/AI-Tutor_Roles.png',
    bubbleKey: 'dialogs.adoptionModal.quizzes.rolesOrganisation.bubble',
    questionKey: 'dialogs.adoptionModal.quizzes.rolesOrganisation.question',
    options: [
      { labelKey: 'dialogs.adoptionModal.quizzes.rolesOrganisation.optionProducts', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.rolesOrganisation.optionSettings', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.rolesOrganisation.optionOrganisation', correct: true },
    ],
  },
  {
    slug: 'verified-exercises',
    image: 'assets/images/Adoption/AI-Tutor_Verifizierte_Uebungen.png',
    bubbleKey: 'dialogs.adoptionModal.quizzes.verifiedExercises.bubble',
    questionKey: 'dialogs.adoptionModal.quizzes.verifiedExercises.question',
    options: [
      { labelKey: 'dialogs.adoptionModal.quizzes.verifiedExercises.optionDozentExercises', correct: true },
      { labelKey: 'dialogs.adoptionModal.quizzes.verifiedExercises.optionKnowledgeBase', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.verifiedExercises.optionIntegrations', correct: false },
    ],
  },
  {
    slug: 'guardrails',
    image: 'assets/images/Adoption/AI-Tutor_Guardrails.png',
    bubbleKey: 'dialogs.adoptionModal.quizzes.guardrails.bubble',
    questionKey: 'dialogs.adoptionModal.quizzes.guardrails.question',
    options: [
      { labelKey: 'dialogs.adoptionModal.quizzes.guardrails.optionRules', correct: true },
      { labelKey: 'dialogs.adoptionModal.quizzes.guardrails.optionKnowledgeBase', correct: false },
      { labelKey: 'dialogs.adoptionModal.quizzes.guardrails.optionIntegrations', correct: false },
    ],
  },
];
